import { render, staticRenderFns } from "./competencyDetailsModal.vue?vue&type=template&id=4eea8429&"
import script from "./competencyDetailsModal.vue?vue&type=script&lang=js&"
export * from "./competencyDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports